import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { DataGrid } from "@mui/x-data-grid";
import "./DashboardSocmed.css";
import { SeverityPill } from "./SeverityPill";
import Loader from "../Components/Loader";

import {
  getSosmedAgentPerformance,
  getSosmedTotalCaseHourly,
  getSosmedTotalCaseSummary,
} from "../Store/Actions/DashboardAction";

const DashboardSocmed = () => {
  const [hourlyData, setHourlyData] = useState([]);
  const [summaryData, setSummaryData] = useState(null);
  const [agentPerformanceData, setAgentPerformanceData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = () => {
    getSosmedTotalCaseHourly()
      .then((response) => {
        if (response.status) {
          setHourlyData(response.data);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });

    getSosmedTotalCaseSummary()
      .then((response) => {
        if (response.status) {
          setSummaryData(response.data);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });

    getSosmedAgentPerformance()
      .then((response) => {
        if (response.status) {
          setAgentPerformanceData(response.data);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    // Fetch data on first render
    fetchData();

    // Fetch data every ten seconds
    const interval = setInterval(() => {
      fetchData();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const optionsCasePerHour = {
    maintainAspectRatio: false,
    responsive: true,

    plugins: {
      datalabels: {
        display: true,
        anchor: 'end',
        align: 'top',
        offset: 0,

        font: {
          weight: 'bold',
          size: 12,
        },
      },

      title: {
        color: "#000",
        display: true,

        font: {
          size: 16,
          weight: 700,
        },

        text: "Created Cases per Hour",
      },
    },

    scales: {
      y: {
        grace: "10%",
      },
    },
  };

  const labelsCasePerHour = hourlyData?.map((data) => data.hour) || [];

  const dataHourly = {
    labels: labelsCasePerHour,

    datasets: [
      {
        label: "Cases",

        data: labelsCasePerHour.map((label) => {
          let data = hourlyData?.find((data) => data.hour === label);
          return data ? data.total : 0;
        }),

        backgroundColor: "#2f53f5",
        borderColor: "#2f53f5",
      },
    ],
  };

  const columnsAgentPerformance = [
    {
      field: "AgentFullName",
      flex: 1.5,
      headerName: "Agent",
    },

    {
      field: "CurrentStatus",
      flex: 1,
      headerName: "Status",
      minWidth: 135,

      renderCell: (params) => (
        <SeverityPill color={params.row.CurrentStatus.toLowerCase()}>
          {params.row.CurrentStatus}
        </SeverityPill>
      ),
    },

    {
      field: "Assign",
      flex: 1,
      headerName: "Assign",
    },

    {
      field: "Done",
      flex: 1,
      headerName: "Done",
    },
  ];

  function renderAgentStatusColor(status) {
    switch (status) {
      case "READY":
        return "#00FF00";

      case "BUSY":
        return "#FF0000";

      case "ACW":
        return "#FFE900";

      case "AUX":
        return "#EE7314";

      default:
        return "#727272";
    }
  }

  return (
    <div className="dashboard-socmed">
      <div className="list_header">
        <div className="list_headerLeft">
          <h1>Social Media</h1>
        </div>
      </div>

      <div className="containerDashboard">
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <section className="cards">
              <div className="item">
                <div>
                  <p className="title">Cases</p>
                  <p className="value">{summaryData?.Cases}</p>
                </div>
              </div>

              <div className="item">
                <div>
                  <p className="title">Resolved</p>
                  <p className="value">{summaryData?.Resolved}</p>
                </div>
              </div>

              <div className="item">
                <div>
                  <p className="title">Avg. Resp</p>
                  <p className="value">{summaryData?.AvgResponseDuration}</p>
                </div>
              </div>

              <div className="item">
                <div>
                  <p className="title">Avg. Case</p>
                  <p className="value">{summaryData?.AvgCaseDuration}</p>
                </div>
              </div>

              <div className="item">
                <div>
                  <p className="title">WA</p>
                  <p className="value">{summaryData?.Channels.WABA}</p>
                </div>
              </div>

              <div className="item">
                <div>
                  <p className="title">IG</p>
                  <p className="value">{summaryData?.Channels.IG}</p>
                </div>
              </div>

              <div className="item">
                <div>
                  <p className="title">FB</p>
                  <p className="value">{summaryData?.Channels.FB}</p>
                </div>
              </div>

              <div className="item">
                <div>
                  <p className="title">Email</p>
                  <p className="value">{summaryData?.Channels.Email}</p>
                </div>
              </div>

              <div className="item lower">
                <div>
                  <p className="title">Agent Status</p>

                  <div className="values">
                    {agentPerformanceData?.AgentStatusSummary?.map((status) => (
                      <div>
                        <p>
                          <span
                            style={{
                              backgroundColor: renderAgentStatusColor(
                                status.Status
                              ),
                            }}
                          />{" "}
                          {status.Status}
                        </p>

                        <p>
                          <b>{status.TotalAgent}</b>
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="item lower">
                <div>
                  <p className="title">Case Status</p>

                  <div className="values">
                    <div>
                      <p>
                        <span style={{ backgroundColor: "#00e1ff" }} /> Agent
                      </p>

                      <p>
                        <b>{summaryData?.Status?.Agent}</b>
                      </p>
                    </div>

                    <div>
                      <p>
                        <span style={{ backgroundColor: "#a626f0" }} /> Chatbot
                      </p>

                      <p>
                        <b>{summaryData?.Status?.ChatBot}</b>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="item lower">
                <div>
                  <p className="title">SLA Response</p>

                  <div className="values">
                    <div>
                      <p>&le; 5m</p>

                      <p>
                        <b>{summaryData?.SLA?.lte_5_min}</b>
                      </p>
                    </div>

                    <div>
                      <p>&le; 10m</p>

                      <p>
                        <b>{summaryData?.SLA?.between_5_10_min}</b>
                      </p>
                    </div>

                    <div>
                      <p>&gt; 10m</p>

                      <p>
                        <b>{summaryData?.SLA?.gt_10_min}</b>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="item lower">
                <div>
                  <p className="title">Queue Waiting</p>

                  <div className="values queue-waiting">
                    <p>{summaryData?.QueueWaiting}</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="item case-per-hour">
              <Line
                data={dataHourly}
                className="table"
                options={optionsCasePerHour}
                plugins={[ChartDataLabels]}
              />
            </section>

            <section className="item agent-performance">
              <header>
                <div className="title">
                  <p>Agent Performance</p>
                </div>
              </header>

              <div className="table-container">
                <DataGrid
                  className="table"
                  columns={columnsAgentPerformance}
                  disableColumnFilter
                  disableColumnMenu
                  disableSelectionOnClick
                  hideFooter
                  loading={isLoading}
                  rows={agentPerformanceData?.AgentTable ?? []}
                  getRowId={(row) => row.AgentFullName}
                />
              </div>
            </section>
          </>
        )}
      </div>
    </div>
  );
};

export default DashboardSocmed;
